import React, { Component } from 'react'
import { jsPDF } from 'jspdf'
import ServiceSubPageHeader from './ServiceSubPageHeader'
import OnlyPremiumEmpty from '../UI/OnlyPremiumEmpty'
import PremiumAlert from '../UI/PremiumAlert'

class ServiceCommandes extends Component {

	constructor(props) {
		super(props)
		const now = new Date()
		now.setHours(0, 0, 0, 0)
		this.state = {
			date: Math.floor(now.getTime() / 1000),
			reservations: [],
			service: null,
			service_benefits: [],
			clients: [],
			panel: null,
			checkedIds: new Set(),
			uncancelledIds: new Set(),
			slotFilter: null,
			showCancelled: false,
			loading: true,
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.services !== this.props.services && !this.state.service) {
			const id = this.props.match.params.id
			const service = (this.props.services || []).find(s => String(s._id) === String(id)) || null
			if (service)
				this.setState({ service }, () => {
					if (this.props.updateNavbarTitle)
						this.props.updateNavbarTitle(service.name)
				})
		}
	}

	componentDidMount() {
		const id = this.props.match.params.id
		const services = this.props.services || []
		const service = services.find(s => String(s._id) === String(id)) || null
		this.setState({ service }, () => {
			if (this.props.updateNavbarTitle)
				this.props.updateNavbarTitle(service ? service.name : 'Commandes')
		})
		Promise.all([
			this.props.fetchClients ? this.props.fetchClients() : Promise.resolve([]),
			this.props.fetchWebappUsers ? this.props.fetchWebappUsers() : Promise.resolve([]),
			this.props.fetchServiceBenefitsByService ? this.props.fetchServiceBenefitsByService(id) : Promise.resolve([]),
		]).then(([clients, , benefits]) => {
			this.setState({ clients: clients || [], service_benefits: benefits || [] }, () => this._loadReservations())
		}).catch(() => this._loadReservations())
	}

	_loadReservations = () => {
		const { date } = this.state
		const id = this.props.match.params.id
		const start = date
		const end = date + 86400
		this.setState({ loading: true })
		this.props.fetchReservationsByDateRange(start, end, id)
		.then(reservations => {
			this.setState({ reservations: reservations || [], loading: false })
		})
		.catch(() => this.setState({ loading: false }))
	}

	// ─── Navigation date ─────────────────────────────────────────────────────────

	_prevDay = () => {
		this.setState({ date: this.state.date - 86400, panel: null }, this._loadReservations)
	}

	_nextDay = () => {
		this.setState({ date: this.state.date + 86400, panel: null }, this._loadReservations)
	}

	_today = () => {
		const now = new Date()
		now.setHours(0, 0, 0, 0)
		this.setState({ date: Math.floor(now.getTime() / 1000), panel: null }, this._loadReservations)
	}

	_isToday = () => {
		const now = new Date()
		now.setHours(0, 0, 0, 0)
		return this.state.date === Math.floor(now.getTime() / 1000)
	}

	_formatDate = (ts) => {
		const d = new Date(ts * 1000)
		const days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']
		const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
		return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()]
	}

	_formatDayFull = (ts) => {
		const d = new Date(ts * 1000)
		const days = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.']
		const months = ['jan.', 'fév.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'éût', 'sep.', 'oct.', 'nov.', 'déc.']
		return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()]
	}

	_formatTime = (ts) => {
		const d = new Date(ts * 1000)
		const h = String(d.getHours()).padStart(2, '0')
		const m = String(d.getMinutes()).padStart(2, '0')
		return h + 'h' + m
	}

	// ─── Données calculées ───────────────────────────────────────────────────────

	_getActiveReservations = () => {
		const { uncancelledIds } = this.state
		return this.state.reservations.filter(r => !r.cancelled || uncancelledIds.has(String(r._id)))
	}

	_getClientName = (r) => {
		if (r.user && typeof r.user === 'object') {
			const name = ((r.user.firstname || '') + ' ' + (r.user.lastname || '')).trim()
			if (name) return name
		}
		if (r.identity) return r.identity
		if (r.client_number) {
			const c = (this.state.clients || []).find(c => c.client_number === r.client_number)
			if (c) return ((c.firstname || '') + ' ' + (c.lastname || '')).trim()
			return '#' + r.client_number
		}
		return 'Campeur inconnu'
	}

	_getClientNumber = (r) => {
		if (r.client_number) return '#' + r.client_number
		if (r.user && typeof r.user === 'object' && r.user.client_number) return '#' + r.user.client_number
		return null
	}

	_getArticleName = (item) => {
		const lang = this.props.lang_default || 'fr'
		if (!item.translations) return item.name || item.subtitle || item.title || 'Article'
		const t = item.translations.find(t => t.lang === lang) || item.translations[0]
		return t ? (t.title || t.subtitle || t.name || 'Article') : 'Article'
	}

	_getQuestions = () => {
		const { service_benefits } = this.state
		if (!service_benefits || service_benefits.length === 0) return []
		return service_benefits[0].questions || []
	}

	_getQTitle = (q) => {
		const lang = this.props.lang_default || 'fr'
		if (!q.translations) return ''
		const t = q.translations.find(t => t.lang === lang) || q.translations[0]
		return t ? (t.title || '') : ''
	}

	_aggregateByArticle = (reservations) => {
		const map = {}
		for (const r of reservations) {
			if (!r.cart) continue
			for (const item of r.cart) {
				const key = String(item._id)
				if (!map[key]) {
					map[key] = {
						id: key,
						name: this._getArticleName(item),
						quantity: 0,
					}
				}
				map[key].quantity += Number(item.quantity) || 0
			}
		}
		return Object.values(map).sort((a, b) => b.quantity - a.quantity)
	}

	_groupBySlot = (reservations) => {
		const map = {}
		for (const r of reservations) {
			const key = r.start
			if (!map[key]) map[key] = { time: r.start, reservations: [] }
			map[key].reservations.push(r)
		}
		return Object.values(map).sort((a, b) => a.time - b.time)
	}

	_getCartTotal = (r) => {
		if (!r.cart) return 0
		return r.cart.reduce((sum, item) => sum + (Number(item.price) || 0) * (Number(item.quantity) || 0), 0)
	}

	_getDayTotal = (reservations) => {
		return reservations.reduce((sum, r) => sum + this._getCartTotal(r), 0)
	}

	_formatEur = (amount) => {
		return amount.toFixed(2).replace('.', ',') + ' €'
	}

	// ─── Statut servi ────────────────────────────────────────────────────────────

	_toggleChecked = (id, e) => {
		e.stopPropagation()
		const checkedIds = new Set(this.state.checkedIds)
		if (checkedIds.has(String(id)))
			checkedIds.delete(String(id))
		else
			checkedIds.add(String(id))
		this.setState({ checkedIds })
	}

	_togglePaid = (id, e) => {
		e.stopPropagation()
		const r = this.state.reservations.find(r => String(r._id) === String(id))
		if (!r) return
		// Paiement CB in-app : statut définitif, non modifiable par le staff.
		if (r.paid_by === 'stripe') return
		const newPaid = !r.paid
		const reservations = this.state.reservations.map(res =>
			String(res._id) === String(id) ? { ...res, paid: newPaid } : res
		)
		this.setState({ reservations })
		if (this.props.payServiceReservation)
			this.props.payServiceReservation(String(id), newPaid)
	}

	_toggleUncancel = (id) => {
		const uncancelledIds = new Set(this.state.uncancelledIds)
		if (uncancelledIds.has(String(id)))
			uncancelledIds.delete(String(id))
		else
			uncancelledIds.add(String(id))
		this.setState({ uncancelledIds })
	}

	// ─── Annulation ──────────────────────────────────────────────────────────────

	_cancel = (id) => {
		this.props.cancelServiceReservation(id)
		.then(() => this._loadReservations())
		.catch(() => this._loadReservations())
	}

	// ─── Export CSV ──────────────────────────────────────────────────────────────

	_downloadCsv = () => {
		const { reservations, service } = this.state
		const active = reservations.filter(r => !r.cancelled)
		const esc = (v) => '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"'

		const headers = ['Date', 'Heure', 'Prénom / Nom', 'N° client', 'Article', 'Quantité', 'Prix unitaire', 'Total commande']
		const rows = [headers.map(esc).join(';')]

		for (const r of active) {
			if (!r.cart) continue
			const d = new Date(r.start * 1000)
			const date = String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + d.getFullYear()
			const heure = this._formatTime(r.start)
			const name = this._getClientName(r)
			const num = this._getClientNumber(r) || ''
			const total = this._getCartTotal(r).toFixed(2)
			for (const item of r.cart) {
				const articleName = this._getArticleName(item)
				const qty = Number(item.quantity) || 0
				const price = Number(item.price) || 0
				rows.push([date, heure, name, num, articleName, qty, price.toFixed(2), total].map(esc).join(';'))
			}
		}

		const blob = new Blob(['\uFEFF' + rows.join('\n')], { type: 'text/csv;charset=utf-8;' })
		const url = URL.createObjectURL(blob)
		const a = document.createElement('a')
		a.href = url
		const d = new Date(this.state.date * 1000)
		const suffix = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0')
		a.download = 'commandes_' + (service ? service.name.replace(/\s+/g, '_') : 'service') + '_' + suffix + '.csv'
		a.click()
		URL.revokeObjectURL(url)
	}

	// ─── Impression ticket ───────────────────────────────────────────────────────

	_printTicket = (r) => {
		const { service } = this.state
		const serviceName = service ? service.name : '—'
		const location = this._getServiceLocation()
		const total = this._getCartTotal(r)
		const isCancelled = !!r.cancelled && !this.state.uncancelledIds.has(String(r._id))
		const questions = this._getQuestions()
		const answers = r.answers && r.answers.length > 0 ? r.answers : []
		const clientNum = this._getClientNumber(r)
		const clientName = this._getClientName(r)

		const W = 80
		const MIN_H = 105
		const margin = 6
		const usable = W - margin * 2
		const lineH = 5.5
		const smallH = 4.5

		const renderContent = (d) => {
			let y = margin

			const addText = (text, opts = {}) => {
				const { size = 9, bold = false, align = 'left', color = [0, 0, 0] } = opts
				d.setFontSize(size)
				d.setFont('helvetica', bold ? 'bold' : 'normal')
				d.setTextColor(...color)
				const x = align === 'center' ? W / 2 : align === 'right' ? W - margin : margin
				d.text(String(text), x, y, { align })
				y += (size >= 10 ? lineH : smallH)
			}
			const addDivider = () => {
				y += 1
				d.setDrawColor(0, 0, 0)
				d.setLineWidth(0.2)
				d.setLineDash([1.5, 1.5])
				d.line(margin, y, W - margin, y)
				d.setLineDash([])
				y += 4
			}
			const addLabel = (text) => {
				d.setFontSize(7)
				d.setFont('helvetica', 'bold')
				d.setTextColor(0, 0, 0)
				d.text(text.toUpperCase(), margin, y)
				y += 4.5
			}
			const addRow = (left, right) => {
				d.setFontSize(8.5)
				d.setFont('helvetica', 'normal')
				d.setTextColor(0, 0, 0)
				const rightW = d.getTextWidth(String(right))
				const leftLines = d.splitTextToSize(String(left), usable - rightW - 2)
				d.text(leftLines, margin, y)
				d.text(String(right), W - margin, y, { align: 'right' })
				y += leftLines.length * smallH
			}

			addText(serviceName, { size: 11, bold: true, align: 'center' })
			if (location)
				addText(location, { size: 8, align: 'center' })
			if (isCancelled)
			{
				y += 1
				d.setFontSize(9)
				d.setFont('helvetica', 'bold')
				d.setTextColor(0, 0, 0)
				d.setDrawColor(0, 0, 0)
				d.setLineWidth(0.3)
				d.rect(margin, y, usable, 6)
				d.text('COMMANDE ANNULÉE', W / 2, y + 4, { align: 'center' })
				y += 8
			}
			addDivider()
			addLabel('Date & retrait')
			addText(this._formatDate(this.state.date), { size: 8.5 })
			addText(this._formatTime(r.start) + (r.end ? ` - ${this._formatTime(r.end)}` : ''), { size: 9, bold: true })
			y += 1
			addDivider()
			addLabel('Panier')
			for (const item of (r.cart || []))
			{
				const name = this._getArticleName(item)
				const qty = Number(item.quantity) || 0
				const price = (Number(item.price) || 0) * qty
				addRow(`${qty}× ${name}`, this._formatEur(price))
			}
			y += 2
			d.setDrawColor(0, 0, 0)
			d.setLineWidth(0.3)
			d.setLineDash([])
			d.line(margin, y, W - margin, y)
			y += 5
			d.setFontSize(10)
			d.setFont('helvetica', 'bold')
			d.setTextColor(0, 0, 0)
			d.text('Total', margin, y)
			d.text(this._formatEur(total), W - margin, y, { align: 'right' })
			y += lineH + 1
			addDivider()
			addLabel('Participant')
			addText(clientName, { size: 9, bold: true })
			if (clientNum)
				addText(`N° ${clientNum}`, { size: 8.5 })
			if (r.phone)
				addText(`Tél : ${r.phone}`, { size: 8.5 })
			if (r.age > 0)
				addText(`${r.age} ans`, { size: 8.5 })
			const answerPairs = questions.map((q, idx) => answers[idx] ? { q: this._getQTitle(q), a: answers[idx] } : null).filter(Boolean)
			if (answerPairs.length > 0)
			{
				addDivider()
				addLabel('Réponses')
				for (const { q, a } of answerPairs)
					addRow(q, a)
			}

			return y
		}

		const measureDoc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: [W, 500] })
		const contentY = renderContent(measureDoc)
		const baseH = Math.max(MIN_H, contentY + 8)
		const H = baseH + 50
		const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: [W, H] })
		renderContent(doc)
		doc.setFontSize(6.5)
		doc.setFont('helvetica', 'normal')
		doc.setTextColor(0, 0, 0)
		doc.text('Commande réalisée via Pocket Camp', W / 2, baseH - 2, { align: 'center' })

		this._printPdf(doc)
	}

	// Déclenche l'impression du navigateur sur le PDF (sans ouvrir d'onglet)
	_printPdf = (doc) => {
		doc.autoPrint()
		const blobUrl = doc.output('bloburl')
		const iframe = document.createElement('iframe')
		iframe.setAttribute('aria-hidden', 'true')
		iframe.style.position = 'fixed'
		iframe.style.right = '0'
		iframe.style.bottom = '0'
		iframe.style.width = '0'
		iframe.style.height = '0'
		iframe.style.border = '0'
		iframe.src = blobUrl
		document.body.appendChild(iframe)
		setTimeout(() => {
			URL.revokeObjectURL(blobUrl)
			if (iframe.parentNode)
				iframe.parentNode.removeChild(iframe)
		}, 60000)
	}

	// ─── Renders ─────────────────────────────────────────────────────────────────



	_renderDateNav = () => {
		const { date } = this.state
		return (
			<div className="flex items-center justify-center gap-4 px-6 py-3 bg-white border-b border-gray-100">
				<button onClick={this._prevDay} className="p-1 rounded hover:bg-gray-100 transition-colors">
					<svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
					</svg>
				</button>
				<span className="text-sm font-medium text-gray-800 min-w-48 text-center">{this._formatDate(date)}</span>
				<button onClick={this._nextDay} className="p-1 rounded hover:bg-gray-100 transition-colors">
					<svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
					</svg>
				</button>
				{!this._isToday() && (
					<button onClick={this._today} className="text-xs text-indigo-600 hover:text-indigo-800 font-medium ml-2">
						Aujourd'hui
					</button>
				)}
			</div>
		)
	}

	_renderRecap = () => {
		const { checkedIds } = this.state
		const active = this._getActiveReservations()
		const articles = this._aggregateByArticle(active)
		const total = this._getDayTotal(active)
		const servedCount = active.filter(r => checkedIds.has(String(r._id))).length
		const remainingCount = active.length - servedCount

		const allDone = remainingCount === 0 && active.length > 0

		return (
			<div className="mx-6 mt-4 grid grid-cols-3 gap-4">
				{/* Carte 1 — Production */}
				<div className="rounded-xl bg-indigo-50 px-5 py-4">
					<p className="text-xs font-semibold text-gray-700 uppercase tracking-wider mb-3">Production</p>
					{articles.length === 0 ? (
						<p className="text-sm text-indigo-300">Aucune commande.</p>
					) : (
						<div className="flex flex-col gap-2">
							{articles.map(a => (
								<div key={a.id} className="flex items-center gap-2">
									<span className="text-base font-bold text-indigo-600 shrink-0">{a.quantity}×</span>
									<span className="text-base text-indigo-900 truncate">{a.name}</span>
								</div>
							))}
						</div>
					)}
				</div>
				{/* Carte 2 — Commandes */}
				<div className="rounded-xl px-5 py-4" style={{ backgroundColor: '#f5f3ff' }}>
					<div className="flex items-start gap-3 mb-3">
						<div className="flex-1 text-left">
							<p className="text-xs font-semibold text-gray-700 uppercase tracking-wider mb-3">Commandes</p>
							<p className="text-4xl font-bold" style={{ color: '#7c3aed' }}>{active.length}</p>
						</div>
						<div className="flex-1 text-left">
							<p className="text-xs font-semibold text-gray-700 uppercase tracking-wider mb-3">DASHBOARD</p>
							<p className="text-4xl font-bold" style={{ color: '#7c3aed' }}>{active.filter(r => r.from === 'dashboard').length}</p>
						</div>
						<div className="flex-1 text-left">
							<p className="text-xs font-semibold text-gray-700 uppercase tracking-wider mb-3">APP</p>
							<p className="text-4xl font-bold" style={{ color: '#7c3aed' }}>{active.filter(r => r.from === 'webapp').length}</p>
						</div>
					</div>
					<p className="text-sm mt-2" style={{ color: '#a78bfa' }}>{this._formatEur(total)}</p>
				</div>
				{/* Carte 3 — À servir */}
				<div className="rounded-xl px-5 py-4" style={{ backgroundColor: allDone ? '#f0fdf4' : '#fff7ed' }}>
					<p className="text-xs font-semibold text-gray-700 uppercase tracking-wider mb-3">
						{allDone ? 'Tout servi' : 'À servir'}
					</p>
					<p className="text-4xl font-bold" style={{ color: allDone ? '#16a34a' : '#ea580c' }}>{remainingCount}</p>
					{servedCount > 0 && (
						<p className="text-sm mt-2" style={{ color: allDone ? '#22c55e' : '#fb923c' }}>
							{servedCount} servie{servedCount > 1 ? 's' : ''} ✓
						</p>
					)}
				</div>
			</div>
		)
	}

	_getFilteredSlots = (slots) => {
		const { slotFilter } = this.state
		if (slotFilter === null) return slots
		return slots.filter(s => s.time === slotFilter)
	}

	_getSlotRemaining = (slot) => {
		const { checkedIds } = this.state
		return slot.reservations.filter(r => !checkedIds.has(String(r._id))).length
	}

	_renderSlotPills = (slots) => {
		const { slotFilter } = this.state
		if (slots.length <= 1) return null

		return (
			<div className="flex items-center gap-2 flex-wrap mb-4">
				<button
					onClick={() => this.setState({ slotFilter: null })}
					className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${slotFilter === null ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
				>
					Tous
				</button>
				{slots.map(slot => {
					const remaining = this._getSlotRemaining(slot)
					const total = slot.reservations.length
					const allDone = remaining === 0
					const isActive = slotFilter === slot.time
					return (
						<button
							key={slot.time}
							onClick={() => this.setState({ slotFilter: isActive ? null : slot.time })}
							className={`px-4 py-2 rounded-full text-sm font-medium transition-colors flex items-center gap-2 ${
								allDone
									? 'bg-green-100 text-green-700'
									: isActive
										? 'bg-indigo-600 text-white'
										: 'bg-gray-100 text-gray-600 hover:bg-gray-200'
							}`}
						>
							{allDone && <span>✓</span>}
							{this._formatTime(slot.time)}
							{!allDone && (
								<span className={`font-bold ${isActive ? 'text-indigo-200' : 'text-gray-400'}`}>
									{remaining}/{total}
								</span>
							)}
						</button>
					)
				})}
			</div>
		)
	}

	_renderCommandeCard = (r) => {
		const { checkedIds, uncancelledIds } = this.state
		const isCancelled = !!r.cancelled && !uncancelledIds.has(String(r._id))
		const isChecked = !isCancelled && checkedIds.has(String(r._id))
		const isPaid = !isCancelled && !!r.paid
		const isStripePaid = isPaid && r.paid_by === 'stripe'
		const questions = this._getQuestions()
		const answers = r.answers && r.answers.length > 0 ? r.answers : []
		const cart = r.cart || []
		const visibleItems = cart.slice(0, 3)
		const extraCount = cart.length - visibleItems.length

		return (
			<div
				key={r._id}
				className={`flex flex-col rounded-xl border overflow-hidden ${
					isCancelled
						? 'bg-gray-50 border-gray-200 opacity-60'
						: isChecked
							? 'bg-green-50/40 border-green-200'
							: 'border-gray-200 bg-white'
				}`}
			>
				{/* Corps */}
				<button
					onClick={() => this.setState({ panel: { type: 'reservation', data: r } })}
					className="flex-1 text-left px-3 pt-3 pb-2 hover:bg-gray-50 transition-colors group focus:outline-none focus:bg-white active:bg-transparent"
				>
					{/* Client */}
					<div className="flex items-center justify-between mb-2">
						<div className="flex items-center gap-1.5 min-w-0">
							<span className={`text-base font-semibold truncate ${isChecked ? 'text-green-700' : 'text-gray-900'}`}>
								{this._getClientName(r)}
							</span>
							{this._getClientNumber(r) && (
								<span className="text-base text-gray-400 shrink-0">{this._getClientNumber(r)}</span>
							)}
						</div>
						{r.from === 'dashboard' ? (
							<span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-gray-100 text-gray-500 shrink-0 ml-2">dashboard</span>
						) : (
							<span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-sky-100 text-sky-600 shrink-0 ml-2">app</span>
						)}
					</div>
					{/* Articles */}
					<div className="flex flex-col gap-0.5 mb-2">
						{visibleItems.map((item, i) => (
							<div key={i} className="flex items-center gap-2">
								<span className={`text-base font-medium shrink-0 ${isChecked ? 'text-green-600' : 'text-indigo-500'}`}>
									{item.quantity}×
								</span>
								<span className={`text-base truncate ${isChecked ? 'text-gray-500' : 'text-gray-700'}`}>
									{this._getArticleName(item)}
								</span>
							</div>
						))}
						{extraCount > 0 && (
							<span className="text-sm text-indigo-400 font-medium">+ {extraCount} autre{extraCount > 1 ? 's' : ''}</span>
						)}
					</div>
					{/* Questions/réponses */}
					{answers.length > 0 && questions.length > 0 && (
						<div className="mb-2 flex flex-col gap-0.5">
							{questions.map((q, idx) => answers[idx] ? (
								<div key={idx} className="flex gap-1 text-sm">
									<span className="text-gray-400 shrink-0">{this._getQTitle(q)} :</span>
									<span className={`${isChecked ? 'text-gray-300' : 'text-gray-600'}`}>{answers[idx]}</span>
								</div>
							) : null)}
						</div>
					)}
					{/* Total + chevron */}
					<div className="flex items-center justify-between pt-1 border-t border-gray-100">
						<span className={`text-base font-semibold ${isChecked ? 'text-green-700' : 'text-gray-800'}`}>
							{this._formatEur(this._getCartTotal(r))}
						</span>
						<svg className="w-4 h-4 text-gray-300 group-hover:text-indigo-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
						</svg>
					</div>
				</button>
				{/* Bouton statut */}
				{isCancelled ? (
					<div className="w-full py-3 text-sm font-semibold flex items-center justify-center gap-2 bg-red-50 text-red-400">
						<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
						</svg>
						Annulée
					</div>
				) : (
				<div className="flex w-full">
					<button
						onClick={(e) => this._toggleChecked(r._id, e)}
						className={`flex-1 py-3 text-sm font-semibold transition-colors flex items-center justify-center gap-2 focus:outline-none active:bg-transparent ${
							isChecked
								? 'bg-green-100 text-green-700 hover:bg-green-200 focus:bg-green-100'
								: 'bg-gray-100 text-gray-500 hover:bg-indigo-50 hover:text-indigo-600 focus:bg-gray-100'
						}`}
					>
						{isChecked ? (
							<>
								<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
								</svg>
								Servi
							</>
						) : (
							<>
								<span className="w-4 h-4 rounded-full border-2 border-gray-400 inline-block" />
								À servir
							</>
						)}
					</button>
					{isStripePaid ? (
						<div className="flex-1 py-3 text-sm font-semibold flex items-center justify-center gap-2 border-l border-white bg-indigo-50 text-indigo-600 cursor-default" title="Payé par carte bancaire dans l'application — statut non modifiable">
							<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h2m4 0h4M5 6h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2z" />
							</svg>
							Payé Stripe
						</div>
					) : (
					<button
						onClick={(e) => this._togglePaid(r._id, e)}
						className={`flex-1 py-3 text-sm font-semibold transition-colors flex items-center justify-center gap-2 focus:outline-none active:bg-transparent border-l border-white ${
							isPaid
								? 'bg-green-100 text-green-700 hover:bg-green-200 focus:bg-green-100'
								: 'bg-gray-100 text-gray-500 hover:bg-emerald-50 hover:text-emerald-600 focus:bg-gray-100'
						}`}
					>
						{isPaid ? (
							<>
								<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
								</svg>
								Payé
							</>
						) : (
							<>
								<span className="w-4 h-4 rounded-full border-2 border-gray-400 inline-block" />
								À payer
							</>
						)}
					</button>
					)}
				</div>
				)}
			</div>
		)
	}

	_renderCreneaux = () => {
		const active = this._getActiveReservations()
		const allSlots = this._groupBySlot(active)
		const slots = this._getFilteredSlots(allSlots)

		return (
			<div className="px-6 mt-4 pb-6 flex flex-col gap-4">
				{active.length === 0 ? (
					<div className="py-12 text-center text-gray-400 text-sm">
						Aucune commande active pour cette journée.
					</div>
				) : (
					<>
						{this._renderSlotPills(allSlots)}
						{slots.map(slot => this._renderCreneauSection(slot))}
					</>
				)}
				{this._renderCancelledToggle()}
			</div>
		)
	}

	_renderCreneauSection = (slot) => {
		const { checkedIds } = this.state
		const remaining = this._getSlotRemaining(slot)
		const sorted = [
			...slot.reservations.filter(r => !checkedIds.has(String(r._id))),
			...slot.reservations.filter(r => checkedIds.has(String(r._id))),
		]

		return (
			<div key={slot.time}>
				<div className="flex items-center justify-between mb-2">
					<span className="text-base font-semibold text-gray-700">{this._formatTime(slot.time)}</span>
					<span className={`text-sm font-medium ${remaining === 0 ? 'text-green-600' : 'text-gray-400'}`}>
						{remaining === 0 ? '✓ Tout servi' : `${remaining} restante${remaining > 1 ? 's' : ''}`}
					</span>
				</div>
				<div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
					{sorted.map(r => this._renderCommandeCard(r))}
				</div>
			</div>
		)
	}

	_renderCancelledToggle = () => {
		const { showCancelled, reservations, uncancelledIds } = this.state
		const cancelled = reservations.filter(r => r.cancelled && !uncancelledIds.has(String(r._id)))
		if (cancelled.length === 0) return null

		return (
			<div className="mt-1">
				<button
					onClick={() => this.setState({ showCancelled: !showCancelled })}
					className="text-xs text-gray-400 hover:text-gray-600 flex items-center gap-1"
				>
					<svg className={`w-3.5 h-3.5 transition-transform ${showCancelled ? 'rotate-90' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
					</svg>
					{showCancelled ? 'Masquer' : 'Voir'} les annulées ({cancelled.length})
				</button>
				{showCancelled && (
					<div className="mt-2 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
						{cancelled.map(r => this._renderCommandeCard(r))}
					</div>
				)}
			</div>
		)
	}

	_getServiceLocation = () => {
		const { service } = this.state
		if (!service || !service.translations) return null
		const lang = this.props.lang_default || 'fr'
		const t = service.translations.find(t => t.lang === lang) || service.translations[0]
		return t ? (t.location || null) : null
	}

	_renderSourceBadge = (from) => {
		if (from === 'dashboard')
			return <span className="text-base px-2 py-0.5 rounded-full bg-green-100 text-green-700 shrink-0">dashboard</span>
		return <span className="text-base px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 shrink-0">app</span>
	}

	_renderPanel = () => {
		const { panel, service } = this.state
		if (!panel) return null

		const closePanel = () => this.setState({ panel: null })
		const serviceName = service ? service.name : '—'
		const location = this._getServiceLocation()
		const questions = this._getQuestions()

		if (panel.type !== 'reservation') return null

		const r = panel.data
		const total = this._getCartTotal(r)
		const isCancelled = !!r.cancelled && !this.state.uncancelledIds.has(String(r._id))
		const answers = r.answers && r.answers.length > 0 ? r.answers : []

		return (
			<>
				<div className="fixed inset-0 bg-black/30 z-40" onClick={closePanel} />
				<div className="fixed top-0 right-0 w-96 bg-white shadow-2xl z-50" style={{ display: 'flex', flexDirection: 'column', height: '100vh', maxHeight: '100vh' }}>

					{/* Header */}
					<div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
						<p className="text-base font-semibold text-gray-900">Détails de la commande</p>
						<button onClick={closePanel} className="text-gray-400 hover:text-gray-700 text-xl leading-none">✕</button>
					</div>

					{/* Contenu */}
					<div className="overflow-y-auto px-5 py-5 space-y-5" style={{ flex: '1 1 0', minHeight: 0, paddingBottom: '80px' }}>

						{/* Service */}
						<div>
							<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">Service</p>
							<div className="border-l-4 border-indigo-500 pl-3">
								<p className="text-base font-semibold text-gray-900">{serviceName}</p>
								{location && <p className="text-base text-gray-400">{location}</p>}
								{isCancelled && <span className="inline-block mt-1 text-xs bg-gray-100 text-gray-500 font-semibold px-2 py-0.5 rounded">Commande annulée</span>}
							</div>
						</div>

						<hr className="border-gray-100" />

						{/* Date & retrait */}
						<div className="flex gap-8">
							<div>
								<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-1">Date</p>
								<p className="text-base text-gray-900">{this._formatDate(this.state.date)}</p>
							</div>
							<div>
								<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-1">Retrait</p>
								<p className="text-base text-gray-900">{this._formatTime(r.start)}{r.end ? ` → ${this._formatTime(r.end)}` : ''}</p>
							</div>
						</div>

						<hr className="border-gray-100" />

						{/* Panier */}
						<div>
							<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">Panier</p>
							<div className="border border-gray-200 rounded-xl overflow-hidden">
								{r.cart && r.cart.map((item, i) => (
									<div key={i} className="flex items-center justify-between px-3 py-2.5 border-b border-gray-100 last:border-0">
										<span className="text-base text-gray-800">{this._getArticleName(item)}</span>
										<div className="flex items-center gap-3">
											<span className="text-base text-gray-400">×{item.quantity}</span>
											<span className="text-base text-gray-700">{this._formatEur((Number(item.price) || 0) * (Number(item.quantity) || 0))}</span>
										</div>
									</div>
								))}
								<div className="flex items-center justify-between px-3 py-2.5 bg-gray-50">
									<span className="text-base font-semibold text-gray-900">Total</span>
									<span className="text-base font-semibold text-gray-900">{this._formatEur(total)}</span>
								</div>
							</div>
						</div>

						<hr className="border-gray-100" />

						{/* Participant */}
						<div>
							<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">Participant</p>
							<div className="border border-gray-200 rounded-xl divide-y divide-gray-100 overflow-hidden">
								{this._getClientNumber(r) && (
									<div className="flex items-center justify-between px-3 py-2.5">
										<span className="text-base text-gray-400">Numéro client</span>
										<span className="text-base font-medium text-gray-800">{this._getClientNumber(r)}</span>
									</div>
								)}
								<div className="flex items-center justify-between px-3 py-2.5">
									<span className="text-base text-gray-400">Nom et prénom</span>
									<span className="text-base font-medium text-gray-800">{this._getClientName(r)}</span>
								</div>
								{r.phone && (
									<div className="flex items-center justify-between px-3 py-2.5">
										<span className="text-base text-gray-400">Téléphone</span>
										<span className="text-base font-medium text-gray-800">{r.phone}</span>
									</div>
								)}
								{r.age > 0 && (
									<div className="flex items-center justify-between px-3 py-2.5">
										<span className="text-base text-gray-700">Âge</span>
										<span className="text-base font-medium text-gray-800">{r.age} ans</span>
									</div>
								)}
							</div>
						</div>

						{/* Réponses aux questions */}
						{answers.length > 0 && questions.length > 0 && (
							<>
								<hr className="border-gray-100" />
								<div>
									<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">Réponses</p>
									{questions.map((q, idx) => answers[idx] ? (
										<div key={idx} className="flex gap-2 text-base mb-0.5">
											<span className="text-gray-400 shrink-0">{this._getQTitle(q)}&nbsp;:</span>
											<span className="text-gray-900">{answers[idx]}</span>
										</div>
									) : null)}
								</div>
							</>
						)}

						<hr className="border-gray-100" />

						{/* Source */}
						<div className="flex items-center gap-2 flex-wrap">
							<p className="text-base text-gray-400">Commandé depuis</p>
							{this._renderSourceBadge(r.from)}
							{r.created_time && (
								<p className="text-base text-gray-400">le {this._formatDayFull(r.created_time)} à {this._formatTime(r.created_time)}</p>
							)}
						</div>
					</div>

					{/* Footer */}
					<div style={{ position: 'fixed', bottom: 0, right: 0, width: '24rem', padding: '16px 20px', borderTop: '1px solid #e5e7eb', backgroundColor: '#ffffff', zIndex: 51 }}>
						<button
							className="w-full text-base font-medium rounded-xl py-2.5 transition-colors flex items-center justify-center gap-2 mb-2"
							style={{ backgroundColor: '#f8fafc', color: '#374151', border: '1px solid #e5e7eb' }}
							onClick={() => this._printTicket(r)}
						>
							<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
							</svg>
							Imprimer ticket
						</button>
						{isCancelled ? (
							<button
								className="w-full text-base font-medium rounded-xl py-2.5 transition-colors"
								style={{ backgroundColor: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0' }}
								onClick={() => { this._toggleUncancel(r._id); closePanel() }}
							>
								Restaurer la commande
							</button>
						) : (
							<button
								className="w-full text-white text-base font-medium rounded-xl py-2.5 transition-colors"
								style={{ backgroundColor: '#f97316', border: 'none' }}
								onClick={() => { this._cancel(r._id); closePanel() }}
							>
								Annuler la commande
							</button>
						)}
					</div>
				</div>
			</>
		)
	}

	render() {
		const { loading } = this.state

		if (this.props.features !== 'premium') {
			return (
				<>
					<OnlyPremiumEmpty
						title="Commandes"
						subtitle="Suivez et encaissez les commandes de vos services de vente"
						emptyFolder="Commencez par créer un service"
						emptyFolderSubtitle="Pas de commandes"
						navName="Services"
						navPath="/Services"
					/>
					<div className="mt-10">
						<PremiumAlert
							content="Mettez votre abonnement à niveau avec la formule premium pour accéder aux services !"
							button_text="En savoir plus"
						/>
					</div>
				</>
			)
		}

		return (
			<div>
				<ServiceSubPageHeader
					title={this.state.service ? this.state.service.name : '—'}
					onBack={() => this.props.history.push('/services')}
					user={this.props.user}
					actions={
						<button
							onClick={this._downloadCsv}
							className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-gray-800 border border-gray-200 rounded-lg px-3 py-1.5 transition-colors"
						>
							<svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
							</svg>
							Exporter CSV
						</button>
					}
				/>
				{this._renderDateNav()}
				{loading ? (
					<div className="flex justify-center items-center py-24 text-gray-400 text-sm">Chargement…</div>
				) : (
					<>
						{this._renderRecap()}
						{this._renderCreneaux()}
					</>
				)}
				{this._renderPanel()}
			</div>
		)
	}
}

export default ServiceCommandes
